import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

//styles
import "./Layout.css"
import SideBar from './SideBar'

interface Props {
    children: React.ReactNode
}


const Layout = ({children}:Props) => {
  const [open, setOpen] = useState<boolean>(false);
  
  return (
    <div className='page-layout'>
        <Header setOpen={setOpen} />
        <SideBar open={open} setOpen={setOpen} ></SideBar>
        {children}
        <Footer />


    </div>
  )
}

export default Layout